import { split } from 'lodash-es';

import { CIError } from 'common/error/error_util';
import gqlClient from 'common/graphql/client';
import { CILogger } from 'common/log/log.provider';

import { GetStudyCustomerForPendoQuery } from './queries';

export async function fetchStudyCustomer(studyId?: string): Promise<{ customerId?: string; customerName?: string }> {
    if (!studyId) {
        return {};
    }

    try {
        const { data } = await gqlClient.query({
            query: GetStudyCustomerForPendoQuery,
            // The study id can carry a version suffix (e.g. "study.x#3"); getStudy expects the base pk.
            variables: { pk: split(studyId, '#')?.[0] },
            // Always resolve the customer from the backend at identify time. A cache-first hit on a
            // Study already normalized without a customer would silently report blank customer fields.
            fetchPolicy: 'network-only',
        });

        return {
            customerId: data.getStudy?.customerId ?? undefined,
            customerName: data.getStudy?.customerName ?? undefined,
        };
    } catch (err) {
        CILogger.getInstance().error(
            'Failed to fetch study customer for Pendo identify',
            CIError.fromGraphQLError(err)
        );

        return {};
    }
}
